<template>
  <div class="modal is-active">
    <div @click="saveAndCloseActive" class="modal-background"></div>
    <button class="close-modal" @click="saveAndCloseActive" aria-label="close"> <i class="fal fa-times fa-3x" qa="close-post"></i></button>
    <div ref="gridModal" class="modal-content" :class="{ 'ios-fix' : iosMobile }">
      <live-chat></live-chat>
    </div>
  </div>
</template>

<script>
import LiveChat from '@/components/SectionProjectView/Tabs/LiveChat'
import componentState from '@/mixins/component-state'
import state from '@/components/SectionProjectView/state'
import auth from '@/mixins/auth'
import userAgent from '@/libs/user-agent'

export default {
  props: ['project'],
  mixins: [componentState, auth],
  components: {
    LiveChat
  },
  computed: {
    iosMobile: function () {
      return userAgent.isIOS()
    },
    userChatType: function () {
      return this._get(state.project.chatType)
    },
    userLiveChatRole: function () {
      return this._get(state.project.role)
    }
  },
  mounted: function () {
    this.fetchMembership()
  },
  methods: {
    saveAndCloseActive: function () {
      this._set(state.grid.modalVisible, false)
      this.$emit('close', true)
    },
    fetchMembership: function () {
      this._set(state.project.chatType, 'LiveChat')
      this.$store.dispatch('getProject', { id: this.project.id, force: false }).then((project) => {
        return this.$store.dispatch('getMembership', { project, user: this.currentUser }).then((membership) => {
          this.canCreate = !!membership
          this._set(state.project.role, membership ? membership.role : 'none')
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

.modal-background {
  background-color: rgba(10, 10, 10, 0.50);
}

.close-modal {
  background: none;
  height: 40px;
  z-index: 10;
  width: 66vw;
  text-align: right;
  color:#fff;
  border:transparent;
  cursor: pointer;
  @include mobile {
    width: 100vw;
    padding-right: 10px;
  }
  @include tablet-only {
    width: 90vw;
  }
  .far {
    -webkit-text-stroke: 1px rgb(255,255,255);
  }
  &:focus,
  &:active {
     outline: 0;
  }
}

.modal-content{
  background-color:#fff;
  width: 60vw;
  margin: 0;
  overflow-x: hidden;
  .main-container{
    border-top: 0;
  }
  @include fullhd {
    max-width: 900px;
  }
  @include tablet-only {
    width: 90%;
    height: 100%;
  }
  @include mobile{
    width: 100vw;
    max-height: 100vh;
    margin: 0 10px;
  }
}

.ios-fix {
  top: 0;
  max-height: 90%;
  margin-bottom: 20px;
  padding-top: 9vh;
}

.nested-modal {
  .modal-content {
    width: 100vw;
    height: 100vh;
    max-width: 100vw;
    max-height: 100vh;
  }
  .close-modal {
    display: none;
  }
}

</style>
